import { scoreAggregate } from "../../functions/score"

export const scoreInitialStateSet = () => {
  let score = {
    scores: Array(10).fill(0),
    questions: {
      "00": {
        qId: "00",
        pId: "",
        question: "",
        answer: 1,
        answerMax: 0,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 0,
        children: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10"],
      },
      "01": {
        qId: "01",
        pId: "00",
        children: ["01.01", "01.02", "01.03", "01.04", "01.05", "01.06"],
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 1,
      },
      "01.01": {
        qId: "01.01",
        pId: "01",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "01.02": {
        qId: "01.02",
        pId: "01",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "01.03": {
        qId: "01.03",
        pId: "01",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "01.04": {
        qId: "01.04",
        pId: "01",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "01.05": {
        qId: "01.05",
        pId: "01",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "01.06": {
        qId: "01.06",
        pId: "01",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "02": {
        qId: "02",
        pId: "00",
        children: ["02.01", "02.02", "02.03", "02.04", "02.05"],
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 1,
      },
      "02.01": {
        qId: "02.01",
        pId: "02",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "02.02": {
        qId: "02.02",
        pId: "02",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "02.03": {
        qId: "02.03",
        pId: "02",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "02.04": {
        qId: "02.04",
        pId: "02",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "02.05": {
        qId: "02.05",
        pId: "02",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "03": {
        qId: "03",
        pId: "00",
        children: ["03.01", "03.02", "03.03", "03.04", "03.05"],
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 1,
      },
      "03.01": {
        qId: "03.01",
        pId: "03",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "03.02": {
        qId: "03.02",
        pId: "03",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "03.03": {
        qId: "03.03",
        pId: "03",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "03.04": {
        qId: "03.04",
        pId: "03",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "03.05": {
        qId: "03.05",
        pId: "03",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "04": {
        qId: "04",
        pId: "00",
        children: ["04.01", "04.02", "04.03", "04.04", "04.05"],
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 1,
      },
      "04.01": {
        qId: "04.01",
        pId: "04",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "04.02": {
        qId: "04.02",
        pId: "04",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "04.03": {
        qId: "04.03",
        pId: "04",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "04.04": {
        qId: "04.04",
        pId: "04",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "04.05": {
        qId: "04.05",
        pId: "04",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "05": {
        qId: "05",
        pId: "00",
        children: ["05.01", "05.02", "05.03", "05.04", "05.05", "05.06"],
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 1,
      },
      "05.01": {
        qId: "05.01",
        pId: "05",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "05.02": {
        qId: "05.02",
        pId: "05",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "05.03": {
        qId: "05.03",
        pId: "05",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "05.04": {
        qId: "05.04",
        pId: "05",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "05.05": {
        qId: "05.05",
        pId: "05",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "05.06": {
        qId: "05.06",
        pId: "05",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "06": {
        qId: "06",
        children: ["06.01", "06.02", "06.03", "06.04", "06.05"],
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 1,
        pId: "00",
      },
      "06.01": {
        qId: "06.01",
        pId: "06",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "06.02": {
        qId: "06.02",
        pId: "06",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "06.03": {
        qId: "06.03",
        pId: "06",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "06.04": {
        qId: "06.04",
        pId: "06",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "06.05": {
        qId: "06.05",
        pId: "06",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "07": {
        qId: "07",
        pId: "00",
        children: ["07.01", "07.02", "07.03", "07.04", "07.05", "07.06"],
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 1,
      },
      "07.01": {
        qId: "07.01",
        pId: "07",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "07.02": {
        qId: "07.02",
        pId: "07",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "07.03": {
        qId: "07.03",
        pId: "07",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "07.04": {
        qId: "07.04",
        pId: "07",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "07.05": {
        qId: "07.05",
        pId: "07",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "07.06": {
        qId: "07.06",
        pId: "07",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "08": {
        qId: "08",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 1,
        pId: "00",
        children: [
          "08.01",
          "08.02",
          "08.03",
          "08.04",
          "08.05",
          "08.06",
          "08.07",
          "08.08",
        ],
      },
      "08.01": {
        qId: "08.01",
        pId: "08",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "08.02": {
        qId: "08.02",
        pId: "08",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "08.03": {
        qId: "08.03",
        pId: "08",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "08.04": {
        qId: "08.04",
        pId: "08",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "08.05": {
        qId: "08.05",
        pId: "08",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "08.06": {
        qId: "08.06",
        pId: "08",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "08.07": {
        qId: "08.07",
        pId: "08",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "08.08": {
        qId: "08.08",
        pId: "08",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "09": {
        qId: "09",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 1,
        pId: "00",
        children: [
          "09.01",
          "09.02",
          "09.03",
          "09.04",
          "09.05",
          "09.06",
          "09.07",
          "09.08",
        ],
      },
      "09.01": {
        qId: "09.01",
        pId: "09",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "09.02": {
        qId: "09.02",
        pId: "09",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "09.03": {
        qId: "09.03",
        pId: "09",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "09.04": {
        qId: "09.04",
        pId: "09",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "09.05": {
        qId: "09.05",
        pId: "09",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "09.06": {
        qId: "09.06",
        pId: "09",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "09.07": {
        qId: "09.07",
        pId: "09",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      "09.08": {
        qId: "09.08",
        pId: "09",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      10: {
        qId: "10",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 1,
        pId: "00",
        children: ["10.01", "10.02", "10.03", "10.04", "10.05"],
      },
      10.01: {
        qId: "10.01",
        pId: "10",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      10.02: {
        qId: "10.02",
        pId: "10",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      10.03: {
        qId: "10.03",
        pId: "10",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      10.04: {
        qId: "10.04",
        pId: "10",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
      10.05: {
        qId: "10.05",
        pId: "10",
        answer: 1,
        answerMax: 4,
        weight: 2,
        scorePercent: 0,
        score: 0,
        scoreMax: 3,
        level: 2,
      },
    },
  }
  score = scoreAggregate(score)
  return score
}

const scoreInitialState = { score: scoreInitialStateSet() }

export default scoreInitialState
